import { STATUS_STYLES, COLOR_CLASSES } from "@/lib/format";

export default function StatusBadge({ status, className = "" }) {
  const s = STATUS_STYLES[status] || { label: status, color: "slate" };
  const c = COLOR_CLASSES[s.color];
  return (
    <span data-testid={`status-badge-${status}`} className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${c.badge} ${className}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${c.dot}`} />
      {s.label}
    </span>
  );
}
